import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

import "@cahaba/App/Store/Reducers";

// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = require.context("./App/Widgets", true, /\.tsx$/)
const onHotWidgetReplace = addWidgetsFromContext(widgets)
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./App/Widgets", true, /\.tsx$/)))
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./App/Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./App/Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./App/Handlers", true)
handlers.keys().forEach(key => handlers(key))

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./App/WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

// GoogleAnalytics Handlers
const googleAnalyticsHandlers = require.context("./App/GoogleAnalytics/Handlers", true);
googleAnalyticsHandlers.keys().forEach(key => googleAnalyticsHandlers(key));

// Load all the extensions to the base pages. This includes style extensions.
const pagesExtensions = require.context("./App/PagesExtensions", true);
pagesExtensions.keys().forEach(key => pagesExtensions(key));

// Load all the extensions to the base components. This includes style extensions.
const componentExtensions = require.context("./App/ComponentExtensions", true);
componentExtensions.keys().forEach(key => componentExtensions(key));

setPreStyleGuideTheme({
    colors: {
        primary: {
            main: "#0D223C",
            contrast: "#FFFFFF"
        },
        secondary: {
            main: "#267795",
        },
        warning: {
            main: "#CD2F00",
        },
    },
    globalStyle: {
        css: css`
            [class^="GridItemStyle"] {
                overflow-wrap: normal;
                word-break: normal;
            }

            [data-test-selector="productListCards_List"] {
                padding-left: 25px;
                padding-right: 25px;
            }

            #react-app > [data-test-selector^="page"] {
                display: flex;
                flex-direction: column;
                min-height: 100vh;
            }

            #react-app > [data-test-selector^="page"] > main {
                flex: 1;
            }
        `,
    },
    typography: {
        fontFamilyImportUrl: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
        body: {
            size: "15px",
            fontFamily: "'Roboto', sans-serif",
            color: "text.main",
        },
        headerPrimary: {
            fontFamily: "'Roboto', sans-serif",
            transform: "none",
            weight: 600,
            size: "17px",
        },
        headerSecondary: {
            size: "17px",
            fontFamily: "'Roboto', sans-serif",
            transform: "none",
            weight: 600,
        },
        headerTertiary: {
            size: "17px",
            fontFamily: "'Roboto', sans-serif",
            transform: "none",
            weight: 600,
        },
    },
});

setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 650, 1100, 1600],
        maxWidths: [540, 540, 900, 1920, 1920],
    },
    button: {
        secondary: {
            css: css`
                background-color: #ffffff;
            `,
        },
    },
});
